var props = {
  name: {
    type: String,
    "default": ""
  },
  size: {
    type: String,
    "default": void 0
  },
  url: {
    type: [String, Array],
    "default": void 0
  },
  loadDefaultIcons: {
    type: Boolean,
    "default": true
  },
  onClick: Function
};

export default props;
//# sourceMappingURL=props.js.map
